const SET_SERVICE_FIELD = 'services/SET_SERVICE_FIELD'
const SET_SERVICE_FIELDS = 'services/SET_SERVICE_FIELDS'
const SET_SERVICE_NEWS_PAGE = 'services/SET_SERVICE_NEWS_PAGE'
const SET_SERVICE_NEWS_ITEMS = 'services/SET_SERVICE_NEWS_ITEMS'

export { SET_SERVICE_FIELD, SET_SERVICE_FIELDS, SET_SERVICE_NEWS_PAGE, SET_SERVICE_NEWS_ITEMS }
